"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        loader: function (_a) {
            var fullscreen = _a.fullscreen;
            return (__assign({ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }, (fullscreen
                ? {
                    zIndex: theme.zIndex.snackbar - 100,
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%',
                    maxHeight: '100%',
                    overflow: 'hidden',
                    backgroundColor: 'rgba(255,255,255,0.50)',
                    color: '#fff',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                }
                : {})));
        },
    });
});
